export enum UserRole {
  OLD_ADMIN = 'SP_CODICES_ADMIN',
  NEW_ADMIN = 'SP_CODICES_COE_ADMIN',
  OLD_PROOFREADER = 'SP_CODICES_READER',
  NEW_PROOFREADER = 'SP_CODICES_COE_READER',
  OLD_LIAISON_OFFICER = 'SP_CODICES_CONTRIBUTOR',
  NEW_LIAISON_OFFICER = 'SP_CODICES_COE_CONTRIBUTOR',
  OLD_ACCOUNTANT = 'SP_CODICES_ACCOUNTANT',
  NEW_ACCOUNTANT = 'SP_CODICES_EXTRAWEB_ACCOUNTANT',
}

export const AdminRoles = [UserRole.NEW_ADMIN, UserRole.OLD_ADMIN]

export const ProofReaderRoles = [
  UserRole.NEW_PROOFREADER,
  UserRole.OLD_PROOFREADER,
]

export const LiaisonOfficerRoles = [
  UserRole.NEW_LIAISON_OFFICER,
  UserRole.OLD_LIAISON_OFFICER,
]

export const AccountantRoles = [
  UserRole.NEW_ACCOUNTANT,
  UserRole.OLD_ACCOUNTANT,
]
